const ENV_URL = process.env.REACT_APP_BACKEND_URL;

const sameHost = () => {
  try {
    return new URL(ENV_URL).host === window.location.host;
  } catch {
    return false;
  }
};

export const API = `${ENV_URL && sameHost() ? ENV_URL : window.location.origin}/api`;
